var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6,
    width: 41,
    height: 41,
    rx: 5.5,
    stroke: "#003366",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2981 30.8462H32.5501C32.6754 30.4772 32.7389 30.0901 32.7375 29.7005C32.7403 29.3256 32.7128 28.9511 32.6555 28.5806H31.2981L30.1045 28.6063L30.1396 27.2419V23.8482L30.0108 23.7195H29.2854C29.0427 23.7063 28.8001 23.7494 28.5768 23.8455C28.3535 23.9415 28.1554 24.0877 27.998 24.2729C27.6693 24.7041 27.5036 25.2376 27.53 25.7791V27.7872C27.5262 28.0607 27.5379 28.3342 27.5651 28.6063H26.6055C25.7278 28.6063 24.7565 28.6485 23.6682 28.7351L23.5979 28.6321C24.2707 27.4239 24.8725 26.1774 25.4001 24.8991L28.3608 18.0508C28.0304 17.7884 27.6332 17.6234 27.214 17.5745C26.7669 17.4797 26.3052 17.4753 25.8564 17.5616L21.5148 27.6257C21.2492 28.1819 21.0754 28.7774 21 29.3892C21.0806 29.9245 21.2894 30.4324 21.6085 30.8696H26.1723L27.5651 30.8181L27.53 32.2083V34.3966C27.9512 34.4695 28.378 34.504 28.8054 34.4996C29.2522 34.5028 29.6986 34.4683 30.1396 34.3966V32.2083L30.1045 30.8181L31.2981 30.8462Z",
    fill: "#003366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step4.cf5293cefc39417e53e95809cd8f2f38.svg";
export { ForwardRef as ReactComponent };